import { Button, Heading, Mockups, Section } from 'components'
// import LeadScore from 'components/ProductMockups/components/LeadScore'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const Hero = ({ heading, text, buttons, featuredImage, kicker }) => {
  return (
    <Section>
      <div className="grid grid-cols-12 items-center gap-16">
        <div className="space-y-8 col-span-4">
          <Heading type="kicker">{kicker}</Heading>
          <Heading level="1">
            <div>{heading}</div>
          </Heading>

          {/* <ParsedContent className="text-gray-500 leading-loose">
            {text}
          </ParsedContent> */}

          <div className="flex flex-wrap w-full space-x-4">
            {buttons.map((button) => (
              <Button
                key={button.label}
                type={button.type}
                to={button.destination.uri}
              >
                {button.label}
              </Button>
            ))}
          </div>
        </div>
        <div className="col-span-8">
          {featuredImage && (
            <div>
              {featuredImage.title === 'LeadBoxer_Product_LowFi' ? (
                <>
                  <div className="relative">
                    {/* <ProductMockup /> */}
                    <Mockups.LeadScore />
                    {/* <LeadScore /> */}
                    {/* <div className="absolute bottom-0 right-0 w-5/12 transform translate-y-20 translate-x-8">
                      <Badges />
                    </div> */}
                  </div>
                </>
              ) : featuredImage.localFile.childImageSharp === null ? (
                <img
                  src={featuredImage.localFile.publicURL}
                  alt={
                    featuredImage.altText
                      ? featuredImage.altText
                      : featuredImage.title
                  }
                />
              ) : (
                <GatsbyImage
                  objectFit="cover"
                  alt={
                    featuredImage.altText
                      ? featuredImage.altText
                      : featuredImage.title
                  }
                  image={getImage(featuredImage.localFile)}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

export default Hero
